import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Navbar from "../../Components/Navbar";
import {
  Bg,
  BoxContainer,
  Underline,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useLocation, useParams } from "react-router-dom";
import TableSetting from "../../Components/Setting/TableSetting";
import { toast } from "react-toastify";
import EditSetting from "../../Components/Setting/EditSetting";
import ViewDetailSetting from "../../Components/Setting/ViewDetailSetting";

const Setting = () => {
  const user = useSelector((state) => state.UserReducer.user);
   const { id } = useParams();
  const location = useLocation();
  const [selectedData, setSelectedData] = useState("");
  const [filterValue, setFilterValue] = useState("");
  // const [filter, setFilter] = useState("phone");
  const [editSetting, setEditSetting] = useState(false);
  const [viewDetail, setViewDetail] = useState(false);


  const [option ,setOption] = useState("phone");
  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(1, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const { t, i18n } = useTranslation();


  const fetchFunction = async () => {
    const body = new FormData();
    body.append("clientId", id);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    body.append("filterType", option);
    body.append("filterValue", filterValue);
    return await axios.post(`${Config.apiUrl}/getsettings`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const {
    isLoading: isLoading,
    mutate: getSettingMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {});

    useEffect(() => {
      const handler = setTimeout(() => {
        getSettingMutate();
      }, 500);
  
      return () => {
        clearTimeout(handler);
      };
    }, [filterValue, startDate, endDate]);


    //-----Edit Setting--------------

    const EditSettingFunction=async(values)=>{
    const body = new FormData();
    // body.append("id",values.id);
    body.append("clientId", id);
    body.append("propId", selectedData.propId);
    body.append("onlinePayment",selectedData.onlinePayment);
    body.append("whatsApp",values.whatsApp);
    body.append("rentReminder",values.rentReminder);
    body.append("markPaidNotification",values.markPaidNotification);
    body.append("onboardWelcome",values.onboardWelcome);
    body.append("ios",values.ios);
    body.append("android", values.android);
    body.append("footer",values.footer);
    body.append("whatsappOnboardingTemplate", values.whatsappOnboardingTemplate);

    return await axios.post(`${Config.apiUrl}/editsettingpref`, body,{
      headers:{
        authorization:"Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };
  const onEditSettingSuccess = (data)=>{
    if (data?.data?.status == "OK"){
    //   toString.success(data?.data?.msg || "Success");
      toast.success(data?.data?.msg || "Success");
      getSettingMutate();
    }
    else{
      toast.error(data?.data?.msg || "An Error Occurred");
    }
    setSelectedData("");
    setEditSetting(false);
  };
  const onEditSettingError=(data)=>{
    setSelectedData("");
    setEditSetting(false);
    toast.error(data?.response?.data?.msg || "An Error Occurred");
  };
  const { isLoading: editSettingLoading, mutate: editSettingMutate} = useMutation(
    EditSettingFunction,{
      onSuccess: onEditSettingSuccess,
      onError: onEditSettingError,
    }
  );
  
  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />

        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>
                {t("Setting")}
                <span>{location?.state?.name}</span>
              </Title>
              <Underline />
            </div>
          </div>
          {editSetting && (
            <EditSetting
               editSettingMutate={editSettingMutate}
               editSettingLoading={editSettingLoading}
               setEditSetting={setEditSetting}
               data={data?.data}
               selectedData={selectedData}
            />
          )}

          {viewDetail && (
            <ViewDetailSetting
              setViewDetail={setViewDetail}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
            />
          )}

          {!error && !isLoading && data && (
            <TableWrapper>
              <TableSetting
                // ApiData={error ? [] : data?.data?.data}
                ApiData={error ? []:
                Array.isArray(data?.data?.data)
                    ? data.data.data
                    : data?.data?.data
                    ? [data.data.data]   // wrap object into array
                    : []
                }
                setSelectedData={setSelectedData}
                setEditSetting={setEditSetting}
                selectedData={selectedData}
                setViewDetail={setViewDetail}
                userType={user.userType}
              />
              {(error || data?.data?.msg == "No data found") && !isLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}
          {(isLoading || isRefetching) && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
};

const TableWrapper = tw.h1`my-10 border  bg-white rounded-md`;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;
export default Setting;


//data                // React Query result
// data.data           // Axios response body
// data.data.data      // Backend "data" field  Question mark means if this exist then ok if not then undefine

// import React, { useState, useEffect } from "react";
// import tw from "tailwind-styled-components";
// import Images from "../../Images";
// import { useMutation } from "react-query";
// import axios from "axios";
// import Config from "../../Config";
// import Loading from "../../Components/Loading";
// import Table from "../../Components/Owners/Tables";
// import Navbar from "../../Components/Navbar";
// import { toast } from "react-toastify";
// import {
//   Bg,
//   BoxContainer,
//   Button,
//   Underline,
// } from "../../Components/Styles/PageStyles";
// import {
//   FieldWrapper,
//   InputGroup,
//   Label,
// } from "../../Components/Styles/InputStyles";
// import { Field, Form, Formik } from "formik";
// import NotFoundModel from "../../Components/NotFoundModel";
// import { useSelector } from "react-redux";
// import { useTranslation } from "react-i18next";
// import MenuItem from "@mui/material/MenuItem";
// import Select from "@mui/material/Select";
// import moment from "moment";
// import EditOwnerModel from "../../Components/Owners/EditOwnerModel";
// import ConvinceFee from "../../Components/Owners/ConvinceFee";
// import AddSubAccountModel from "../../Components/Owners/AddSubAccountModel";
// import AddOwnerModel from "../../Components/Owners/AddOwnerModel";
// import ViewDetailModel from "../../Components/Owners/ViewDetail";
// import AddCharges from "../../Components/Owners/AddCharges";
// import UploadLogo from "../../Components/Owners/UploadLogo";
// import { MdAdd } from "react-icons/md";
// import { useLocation, useParams } from "react-router-dom";
// import UploadLeads from "../../Components/Owners/UploadLeads";

// const Owners = () => {

//   const user = useSelector((state) => state.UserReducer.user);
//   const [selectedData, setSelectedData] = useState("");
//   const [fetchData, setFetchData] = useState([]);
//   const [filterValue, setFilterValue] = useState("");
//   const [filter, setFilter] = useState("mobile");
//   const [editUser, setEditUser] = useState(false);
//   const [convinceFee, setConvinceFee] = useState(false);
//   const [addSubAccount, setAddSubAccount] = useState(false);
//   const [uploadLogo, setUploadLogo] = useState(false);
//   const [uploadLeads, setUploadLeads] = useState(false);
//   const [addCharges, setAddCharges] = useState(false);
//   const [addOwner, setAddOwner] = useState(false);
//   const [viewDetail, setViewDetail] = useState(false);
//   const [linkCharges, setLinkCharges] = useState(null);
//  const [apiData, setApiData] = useState();

//   const [startDate, setStartDate] = useState(

//     moment(new Date()).subtract(90, "days").format("YYYY-MM-DD")
//   );
//   const [endDate, setEndDate] = useState(
//     moment(new Date()).format("YYYY-MM-DD")
//   );
//   const { t, i18n } = useTranslation();

//   const initialValues = {
//     name: "",
//     payuKey: "",
//     payuMid: "",
//     email: "",
//     clintId: "",
//     filterVal: filterValue,
//     startDate: moment(new Date()).subtract(90, "days").format("YYYY-MM-DD"),
//     endDate: moment(new Date()).format("YYYY-MM-DD"),
//   };

//   const fetchFunction = async () => {
//     const body = new FormData();
//     body.append("filterType", filter);
//     body.append("filterValue", filterValue);
//     body.append("startDate", startDate);
    
//     body.append("endDate", endDate);
//     return await axios.post(`${Config.apiUrl}/getusers`, body, {
//       headers: {
//         authorization: "Bearer" + " " + user.token,
//         "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
//       },
//     });
//   };

//   const getOwnersSuccess = (res) => {
//     if (res.data.status == "NOK" || res.data.data == false) {
//       error = true;
//     } else setFetchData(res.data.data);
//   };

//   const getOwnersError = (res) => { 
    
//   };

//   const {
//     isLoading: isLoadings,
//     mutate: getOwnersMutate,
//     error,
//     data,
//     isRefetching,
//   } = useMutation(fetchFunction, {
//     onSuccess: getOwnersSuccess,
//     onError: getOwnersError,
//   });

//   useEffect(() => {
//     const handler = setTimeout(() => {
//       getOwnersMutate();
//     }, 500);

//     return () => {
//       clearTimeout(handler);
//     };
//   }, [filterValue, startDate, endDate]);

//   const submitHandler = (values) => {
//     const newValues = {
//       startDate: moment(values.startDate).format("YYYY-MM-DD"),
//       endDate: moment(values.endDate).format("YYYY-MM-DD"),
//     };
//     setStartDate(newValues.startDate);
//     setEndDate(newValues.endDate);
//     getOwnersMutate();
//   };
//   const ChangeHandler = (e) => {
//     setFilterValue(e.target.value);
//   };

//   // --------Upload logo---------
//   const uploadLogoFunction = async (values) => {
//     const formData = new FormData();
//     formData.append("clientId", values.id);
    
//     formData.append("logo", values.ownerLogoImage);

//     return await axios.post(`${Config.apiUrl}/uploadlogo`, formData, {
//       headers: {
//         authorization: "Bearer " + user.token,
//         "Content-Type": "multipart/form-data",
//       },
//     });
//   };

//   const onUploadLogoSuccess = (data) => {
//     if (data?.data?.status === "OK") {
//       toast.success(data?.data?.msg || "Logo uploaded successfully!");
//       setFetchData((prevData) =>
//         prevData.map((owner) =>
//           owner.id === selectedData.id
//             ? { ...owner, logoPath: data.data.logoPath }
//             : owner
//         )
//       );
//     } else {
//       toast.error(data?.data?.msg || "An error occurred.");
//     }
//     setUploadLogo(false);
//     setSelectedData("");
//   };

//   const onUploadLogoError = (error) => {
//     toast.error(error?.response?.data?.msg || "An error occurred.");
//     setUploadLogo(false);
//   };

//   const { isLoading: uploadLogoLoading, mutate: uploadLogoMutate } =
//     useMutation(uploadLogoFunction, {
//       onSuccess: onUploadLogoSuccess,
//       onError: onUploadLogoError,
//     });

// /***************** Upload Leads ****************/

//   // --------Upload logo---------
//   const uploadLeadsFunction = async (values) => {
//     const formData = new FormData();
//     formData.append("clientId", selectedData.id);
    
//     formData.append("fileName", values[0]);

//     return await axios.post(`${Config.apiUrl}/uploadleads`, formData, {
//       headers: {
//         authorization: "Bearer " + user.token,
//         "Content-Type": "multipart/form-data",
//       },
//     });
//   };

//   const onUploadLeadsSuccess = (data) => {
//     if (data?.data?.status === "OK") {
//       toast.success(data?.data?.msg || "Leads uploaded successfully!");
//       setFetchData((prevData) =>
//         prevData.map((owner) =>
//           owner.id === selectedData.id
//             ? { ...owner, logoPath: data.data.logoPath }
//             : owner
//         )
//       );
//     } else {
//       toast.error(data?.data?.msg || "An error occurred.");
//     }
//     setUploadLeads(false);
//     setSelectedData("");
//   };

//   const onUploadLeadsError = (error) => {
//     toast.error(error?.response?.data?.msg || "An error occurred.");
//     setUploadLeads(false);
//   };
  
//   const { isLoading: uploadLeadsLoading, mutate: uploadLeadsMutate } =
//     useMutation(uploadLeadsFunction, {
//       onSuccess: onUploadLeadsSuccess,
//       onError: onUploadLeadsError,
//     });



//   // --------Add Owner---------
//   const addOwnerfunction = async (values) => {
//     const formData = new FormData();
//     formData.append("name", values.name);
//     formData.append("mobile", values.mobile);
//     formData.append("city", values.city);
//     formData.append("propertyCount", values.propertyCount);
//     return await axios.post(`${Config.apiUrl}/addclient`, formData, {
//       headers: {
//         authorization: "Bearer " + user.token,
//         "Content-Type": "multipart/form-data",
//       },
//     });
//   };

//   const onAddOwnerSucess = (data) => {
//     if (data?.data?.status === "OK") {
//       toast.success(data?.data?.msg || "Add Owner successfully!");
//     } else {
//       toast.error(data?.data?.msg || "An error occurred.");
//     }
//     getOwnersMutate();
//     setAddOwner(false);
//     setSelectedData("");
//   };

//   const onAddOwnerError = (error) => {
//     toast.error(error?.response?.data?.msg || "An error occurred.");
//     setAddOwner(false);
//   };
//   const { isLoading: isRegisterLoading, mutate: addOwnerMutate } =
//     useMutation(addOwnerfunction, {
//       onSuccess: onAddOwnerSucess,
//       onError: onAddOwnerError,
//     });



//   //------- Edit Owner Single Entry -------
//   const EditOwnerFunction = async (values) => {

//     const body = new FormData();
//     body.append("id", values.id);
//     body.append("name", values.name);
//     body.append("acquiredBy", values.acquiredBy);
//     body.append("holdOutBalance", values.holdOutBalance);
//     body.append("email", values.email);
//     body.append("mobile", values.mobile);
//     body.append("status", values.status);
//     body.append("panNumber", values.panNumber);
//     body.append("isBankDetailsShown", values.isBankDetailsShown);
//     body.append("paymentGateway", values.paymentGateway);
//     body.append("systemAlerts", values.systemAlerts);
//     return await axios.post(`${Config.apiUrl}/editowner`, body, {
//       headers: {
//         authorization: "Bearer" + " " + user.token,
//         "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
//       },
//     });
//   };
//   const onEditEntrySuccess = (data) => {
//     if (data?.data?.status == "OK") {
//       toast.success(data?.data?.msg || "Success");
//       // getOwnersMutate();
//     } else {
//       toast.error(data?.data?.msg || "An Error Occured");
//     }
//     setSelectedData("");
//     setEditUser(false);
//     setFetchData(data?.data?.data);
//   };
//   const onEditEntryError = (data) => {
//     setSelectedData("");
//     setEditUser(false);
//     toast.error(data?.response?.data?.msg || "An Error Occured");
//   };
//   const { isLoading: editEntryLoading, mutate: editOwnerMutate } = useMutation(
//     EditOwnerFunction,
//     {
//       onSuccess: onEditEntrySuccess,
//       onError: onEditEntryError,
//     }
//   );
//   //--------- AddSubAccount------------
//   const AddSubAccountFunction = async (values) => {
//     const body = new FormData();
//     body.append("id", values.id);
//     body.append("payuMid", values.payuMid);
//     body.append("payuKey", values.payuKey);
//     return await axios.post(`${Config.apiUrl}/editsubaccount`, body, {
//       headers: {
//         authorization: "Bearer" + " " + user.token,
//         "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
//       },
//     });
//   };
//   const onAddSubAccountSuccess = (data) => {
//     if (data?.data?.status == "OK") {
//       toast.success(data?.data?.msg || "Success");
//       // getOwnersMutate();
//     } else {
//       toast.error(data?.data?.msg || "An Error Occured");
//     }
//     setSelectedData("");
//     setAddSubAccount(false);
//     setFetchData(data?.data?.data);
//   };
//   const onAddSubAccountError = (data) => {
//     setSelectedData("");
//     setAddSubAccount(false);
//     toast.error(data?.response?.data?.msg || "An Error Occured");
//   };
//   const { isLoadings: AddSubAccountLoading, mutate: AddSubAccountMutate } = useMutation(
//     AddSubAccountFunction,
//     {
//       onSuccess: onAddSubAccountSuccess,
//       onError: onAddSubAccountError,
//     }
//   );

//   // ConvinceFee--------------//
  
//   const ConvinceFeeFunction = async ( {values, clientId }) => {
//     const formData = new FormData();
//     formData.append("clientId", clientId);
//     formData.append("otherCharges", values.otherCharges);
//     formData.append("upiEnabled", values.upiEnabled);
//     formData.append("netBankingEnabled", values.netBankingEnabled);
//     formData.append("creditCardEnabled", values.creditCardEnabled);
//     formData.append("upiCharges", values.upiCharges);
//     formData.append("creditCardCharges", values.creditCardCharges);
  
//     return axios.post(`${Config.apiUrl}/updateclientpaymentmodes`, formData, {
//       headers: {
//         authorization: "Bearer " + user.token,
//         "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
//       },
//     });
//   };
  
  
//   const ConvinceFeeSuccess = (data) => {
//     // console.log(data?.data?.data)
//     const updated = data?.data?.data;
//     setSelectedData(updated);
//     setFetchData(data?.data?.data);
//     toast.success(data?.data?.msg || "Success");
//     setConvinceFee(false);
//     getOwnersMutate();
//   };
  
//   const ConvinceFeeError = (data) => {
//     setConvinceFee(false);
//     setSelectedData("");
//     toast.error(data?.response?.data?.msg || "An Error Occured");
//   };

//   const { isLoadings: ConvinceFeeLoading, mutate: ConvinceFeeMutate } =
//     useMutation(ConvinceFeeFunction, {
//       onSuccess: ConvinceFeeSuccess,
//       onError: ConvinceFeeError,
//     });


//   return (
//     <>
//       <Bg
//         style={{
//           backgroundImage: `url(${Images.BeamsBg})`,
//           backgroundRepeat: "no-repeat",
//           backgroundSize: "contain",
//           backgroundPosition: "top left",
//           height: "100vh",
//         }}
//       >
//         <Navbar />

//         {/* <Page> */}
//         <BoxContainer>
//           <div className="flex w-full justify-between items-center">
//             <div>
//               <Title>{t("Owners")}</Title>
//               <Underline />
//             </div>
//             <UploadWrapper>
//               <Button type="button" onClick={() => setAddOwner(true)}>
//                 <MdAdd className="text-white w-5 h-5" />{" "}
//                 <p className="text-sm">{"Add Owner"}</p>
//               </Button>
//             </UploadWrapper>
//           </div>

//           <div className="flex w-full justify-between items-center">
//             <Filters
//               submitHandler={submitHandler}
//               initialValues={initialValues}
//               InitialLoading={isLoadings}
//               setFilter={setFilter}
//               setFilterValue={setFilterValue}
//               ChangeHandler={ChangeHandler}
//               filterValue={filterValue}
//               filter={filter}
//               user={user}
//               // setIsEditLeadVisible={setIsEditLeadVisible}
//               t={t}
//             />
//           </div>

       

//           {editUser && (
//             <EditOwnerModel
//               editOwnerMutate={editOwnerMutate}
//               editEntryLoading={editEntryLoading}
//               setEditUser={setEditUser}
//               data={data?.data}
//               selectedData={selectedData}
              
//             />
//           )}

//           {convinceFee && (
//             <ConvinceFee
//             setLinkCharges={setLinkCharges}
//               editOwnerMutate={editOwnerMutate}
//               ConvinceFeeMutate={ConvinceFeeMutate}
//               ConvinceFeeLoading={ConvinceFeeLoading}
//               setConvinceFee={setConvinceFee}
//               data={data?.data}
//               selectedData={selectedData}
//             />
//           )}
          

//           {addSubAccount && (
//             <AddSubAccountModel
//               AddSubAccountMutate={AddSubAccountMutate}
//               AddSubAccountLoading={AddSubAccountLoading}
//               setAddSubAccount={setAddSubAccount}
//               data={data?.data}
//               selectedData={selectedData}
//             />
//           )}
//           {addOwner && (
//             <AddOwnerModel
//               setAddOwner={setAddOwner}
//               selectedData={selectedData}
//               isRegisterLoading={isRegisterLoading}
//               addOwnerMutate={addOwnerMutate}
//             />
//           )}

//           {uploadLogo && (
//             <UploadLogo
//               uploadLogoMutate={uploadLogoMutate}
//               uploadLogoLoading={uploadLogoLoading}
//               setUploadLogo={setUploadLogo}
//               selectedData={selectedData}
//               data={data?.data}
//             />
//           )}

//           {uploadLeads && (
//             <UploadLeads
//             uploadLeadsMutate={uploadLeadsMutate}
//               uploadLeadsLoading={uploadLeadsLoading}
//               setUploadLeads={setUploadLeads}
//               selectedData={selectedData}
//               data={data?.data}
//             />
//           )}

//           {viewDetail && (
//             <ViewDetailModel
//               setViewDetail={setViewDetail}
//               selectedData={selectedData}
//               setSelectedData={setSelectedData}
//               setUploadLogo={setUploadLogo}
//             />
//           )}
//           {addCharges && (
//             <AddCharges
//               setAddCharges={setAddCharges}
//               selectedData={selectedData}
//             />
//           )}
//           {!error && !isLoadings && data && (
//             <TableWrapper>
//               <Table
//                 ApiData={fetchData || []}
//                 setSelectedData={setSelectedData}
//                 selectedData={selectedData}
//                 setEditUser={setEditUser}
//                 setConvinceFee={setConvinceFee}
//                 setAddSubAccount={setAddSubAccount}
                
//                 setViewDetail={setViewDetail}
//                 userType={user.userType}
//                 setAddCharges={setAddCharges}
//                 setUploadLogo={setUploadLogo}
//                 setUploadLeads={setUploadLeads}
//               />
//               {(error || data?.data?.msg == "No data found") && !isLoadings && (
//                 <NotFoundModel />
//               )}
//             </TableWrapper>
//           )}
//           {(isLoadings || isRefetching) && <Loading />}
//         </BoxContainer>
//       </Bg>
//     </>
//   );
// };

// const Filters = ({
//   initialValues,
//   submitHandler,
//   InitialLoading,
//   user,
//   filter,
//   setFilter,
//   setFilterValue,
//   filterValue,
//   ChangeHandler,
//   t,
// }) => {
//   const today = moment().format("YYYY-MM-DD");
//   return (
//     <Formik initialValues={initialValues} onSubmit={submitHandler}>
//       <Form className="w-full">
//         <FilterContainer>
//           <div className="flex gap-2 items-end sm:text-base text-xs flex-wrap">
//             <div className="flex items-end gap-2">
//               <InputGroup className="max-w-[200px]">
//                 <Label htmlFor="startDate">{t("Start_Date")}:</Label>
//                 <FieldWrapper className="h-10">
//                   <img
//                     src={Images.Calender}
//                     alt="Calender icon"
//                     className="w-3.5"
//                   />
//                   <Field
//                     type="date"
//                     name="startDate"
//                     id="startDate"
//                     className="ml-1"
//                     max={today}
//                   />
//                 </FieldWrapper>
//               </InputGroup>

//               <InputGroup className="max-w-[130px]">
//                 <Label htmlFor="endDate">{t("End_Date")}:</Label>
//                 <FieldWrapper className="h-10">
//                   <img
//                     src={Images.Calender}
//                     alt="Calender icon"
//                     className="w-3.5"
//                   />
//                   <Field
//                     type="date"
//                     name="endDate"
//                     id="endDate"
//                     className="ml-1"
//                     max={today}
//                   />
//                 </FieldWrapper>
//               </InputGroup>
//             </div>
//             <ApplyBtn disabled={InitialLoading} type="submit">
//               {t("Date_filter")}
//             </ApplyBtn>
//           </div>

//           <div className="flex gap-4 items-end">
//             {filter !== "status" && filter !== "paystatus" ? (
//               <InputGroup className="max-w-[200px]">
//                 <Label htmlFor="filterVal">{("")}</Label>
//                 <Field
//                   className="border border-slate-300 rounded-md px-4 focus:ring-1 focus:ring-primary-color focus:border-primary-color py-2 ml-1"
//                   placeholder="Search..."
//                   type="text"
//                   name="filterVal"
//                   id="filterVal"
//                   inputMode={filter === "mobile" ? "numeric" : "text"}
//                   maxLength={filter === "mobile" ? "10" : undefined}
//                   pattern={filter === "mobile" ? "[0-9]*" : undefined}
//                   value={filterValue}
//                   onChange={(e) => {
//                     if (filter === "mobile" || filter === "id") {
//                       const value = e.target.value;
//                       // Restrict input to digits only, up to 10 characters
//                       if (/^\d{0,10}$/.test(value)) {
//                         ChangeHandler(e);
//                       }
//                     } else {
//                       ChangeHandler(e);
//                     }
//                   }}
//                 />
//               </InputGroup>
//             ) : filter === "status" ? (
//               <InputGroup
//                 className="min-w-[120px]"
//                 style={{ flexBasis: "content" }}
//               >
//                 <Label htmlFor="filter">{t("Select")}</Label>
//                 <Select
//                   autoComplete="off"
//                   className="px-2 bg-transparent text-sm border-none"
//                   style={{ height: "40px" }}
//                   value={filterValue}
//                   onChange={ChangeHandler}
//                 >
//                   <MenuItem value="" disabled>
//                     {t("Select Status")}
//                   </MenuItem>
//                   <MenuItem value="3">{t("Active")}</MenuItem>
//                   <MenuItem value="4">{t("Enrolled")}</MenuItem>
//                 </Select>
//               </InputGroup>
//             ) : null}

//             <InputGroup
//               className="min-w-[120px]"
//               style={{ flexBasis: "content" }}
//             >
//               <Label htmlFor="filter">{t("Search By")}</Label>

//               <Select
//                 autoComplete="off"
//                 className="w-24 px-2 bg-transparent text-sm border-none"
//                 style={{ height: "40px" }}
//                 value={filter}
//                 onChange={(e) => {
//                   setFilter(e.target.value);
//                   setFilterValue("");
//                 }}
//               >
//                 <MenuItem value="name">Name</MenuItem>
//                 <MenuItem value="mobile">Phone</MenuItem>
//                 <MenuItem value="status">Status</MenuItem>
//                 <MenuItem value="id">ID</MenuItem>
//                 {user.userType !== Config.userType.OPERATION && (
//                 <MenuItem value="city">City</MenuItem>
//                 )}
//               </Select>
//             </InputGroup>
//           </div>
//         </FilterContainer>
//       </Form>
//     </Formik>
//   );
// };

// const TableWrapper = tw.h1`my-10 border  bg-white rounded-md `;
// const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
// const ApplyBtn = tw.button`${(p) =>
//   p.$active
//     ? "bg-gray-100"
//     : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
// const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;
// const UploadWrapper = tw.div`w-full flex justify-end space-x-4 items-center `;
// export default Owners;
